/**
 * 使用crypto.js 进行加密解密
 * 因插件不兼容安卓5，顾改成按需加载cdn文件
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/**
 * 三种情况 条件：1. 弹窗visible=true ，2.在58app
 * 1. 初始化的时候获取用户信息手机号 - 调用接口 （如无数据则不需要调用）
 * 2. 信息填写完成，未勾选隐私协议的时候 - 调用接口（数据使用当前填写的数据）
 * 3. 提交成功调用旧接口增加字段
 */
// import CryptoJS from 'crypto-js';
/**
 * 因crypto-js不兼容安卓6以下版本58app,会造成页面白屏，顾改成动态引入方式
 * 如需更新crypto-js库版本，请从https://cdnjs.cloudflare.com/ajax/libs/crypto-js/版本号/crypto-js.min.js下载对应版本代码上传到optimiz_u8仓库的 origin/lib/目录下，在更新此处引入的地址
 */
/** 密钥 前后端定义一致 ##不能随意修改## 每个业务线key不同 */
import { loadScript } from './tools';
var defaultSecretKey = 'oYCMyuHVQRGTWadK';
var CryptoJSObj;
var getCryptoJS = function () {
    return new Promise(function (resolve, reject) {
        if (CryptoJSObj) {
            resolve(CryptoJSObj);
            return;
        }
        loadScript({ url: "//ss.xgo-img.com.cn/lib/crypto-js.4.1.1.min.js" }).then(function () {
            CryptoJSObj = window.CryptoJS;
            resolve(CryptoJSObj);
        });
    });
};
/**
 * 加密方法
 * @param data -- 需要加密的数据
 * @param secretKey -- 加密的key 随业务线不同
 *
 */
var encryptDataFn = function (data, secretKey) { return __awaiter(void 0, void 0, void 0, function () {
    var CryptoJS, text, key, encrypted;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getCryptoJS()];
            case 1:
                CryptoJS = _a.sent();
                if (!CryptoJS || !(CryptoJS === null || CryptoJS === void 0 ? void 0 : CryptoJS.enc)) {
                    return [2 /*return*/, data];
                }
                text = JSON.stringify(data);
                text = CryptoJS.enc.Utf8.parse(text);
                key = CryptoJS.enc.Utf8.parse(secretKey || defaultSecretKey);
                encrypted = CryptoJS.AES.encrypt(text, key, {
                    mode: CryptoJS.mode.ECB,
                    padding: CryptoJS.pad.Pkcs7,
                });
                return [2 /*return*/, CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(encrypted)).toString()];
        }
    });
}); };
/**
 * 解密
 * @param data
 */
var decryptDataFn = function (data, secretKey) { return __awaiter(void 0, void 0, void 0, function () {
    var CryptoJS, encrypted, key, decrypted;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getCryptoJS()];
            case 1:
                CryptoJS = _a.sent();
                encrypted = CryptoJS.enc.Utf8.stringify(CryptoJS.enc.Base64.parse(data)).toString();
                key = CryptoJS.enc.Utf8.parse(secretKey || defaultSecretKey);
                decrypted = CryptoJS.AES.decrypt(encrypted, key, {
                    mode: CryptoJS.mode.ECB,
                    padding: CryptoJS.pad.Pkcs7,
                });
                return [2 /*return*/, CryptoJS.enc.Utf8.stringify(decrypted).toString()];
        }
    });
}); };
export { encryptDataFn, decryptDataFn };
